export namespace HelpfulHints {
	let setupAccordion = () => {
		let helpfulHints = document.querySelectorAll('.js-helpful-hints');

		helpfulHints.forEach((helpfulHint) => {
			let triggers = helpfulHint.querySelectorAll('.js-helpful-hints-trigger');

			triggers.forEach((trigger) => {
				trigger.addEventListener('click', (e) => {
					if(trigger.getAttribute('aria-expanded') === 'false') {
						trigger.setAttribute('aria-expanded', 'true');
					} else {
						trigger.setAttribute('aria-expanded', 'false');
					}
					let parent = trigger.closest('li');
					let contentDiv = parent.querySelector('.js-helpful-hints-content');
					parent.classList.toggle('state-open');
					e.preventDefault();
				});
			});
		});
	}

	export const init = () => {
		setupAccordion();
	}
}


document.addEventListener('DOMContentLoaded', HelpfulHints.init);
